import { render } from "./bom-icon.vue?vue&type=template&id=2605259c&ts=true"
import script from "./bom-icon.vue?vue&type=script&lang=ts"
export * from "./bom-icon.vue?vue&type=script&lang=ts"

import "./bom-icon.vue?vue&type=style&index=0&id=2605259c&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__